// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lRS2u7PTqb0ZdQL0IriH{margin-bottom:20px}.lRS2u7PTqb0ZdQL0IriH:last-of-type{margin-bottom:0}.lRS2u7PTqb0ZdQL0IriH .qiB7r1g_1tk75TTFoXgf{padding:8px}.Dne1kbi4CXwtFbixZGfI{margin:0;padding:0;list-style:none}.Dne1kbi4CXwtFbixZGfI ul{margin:0;padding:0 0 0 20px;list-style:none}.LC_JStVyoEWG2mDuMu4k{position:relative}.lRS2u7PTqb0ZdQL0IriH ul .TlQYnUazo_ESwBWEUiPO{box-shadow:0 0 0 1.5px var(--interaction-brand-active)inset;border-radius:6px}.u74EM8gZE0IGkh3lZnE2{position:relative}.u74EM8gZE0IGkh3lZnE2:before{width:100%;height:100%;z-index:var(--zIndex-BASE_10);content:"";background-color:rgba(255,255,255,.8);position:absolute;top:0;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `lRS2u7PTqb0ZdQL0IriH`,
	"empty": `qiB7r1g_1tk75TTFoXgf`,
	"treeRoot": `Dne1kbi4CXwtFbixZGfI`,
	"placeholderContainer": `LC_JStVyoEWG2mDuMu4k`,
	"dropTarget": `TlQYnUazo_ESwBWEUiPO`,
	"draggingSource": `u74EM8gZE0IGkh3lZnE2`
};
export default ___CSS_LOADER_EXPORT___;
